import { TailSpin } from 'react-loader-spinner';
import { useEffect } from 'react';

const Loader = () => {
  useEffect(() => {
    // Add the class to the body when the component is mounted
    document.body.classList.add('no-scroll');

    // Remove the class when the component is unmounted
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <div className="loader-container">
      <TailSpin height="80" width="80" color="#ec1c24" />
    </div>
  );
};

export default Loader;